import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import tokens from '../theme/tokens';

// 담당 기사 — 가린 이름(김*선)·차량. 연락처는 내보내지 않는다(문의는 머리의 고객센터)
const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    padding: '16px 20px',
    borderRadius: tokens.radiusLg,
    backgroundColor: tokens.surface,
    boxShadow: tokens.cardShadow,
  },
  avatar: {
    flex: '0 0 44px',
    height: 44,
    borderRadius: 22,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.primarySoft,
    color: tokens.primaryDark,
    fontSize: 18,
    fontWeight: 700,
  },
  name: { display: 'block', fontSize: 16, fontWeight: 700, letterSpacing: -0.6, color: tokens.ink, lineHeight: 1.4 },
  meta: { display: 'block', marginTop: 2, fontSize: 13, letterSpacing: -0.4, color: tokens.muted },
}));

function TrackRider({ rider, express }) {
  const cs = useStyles();
  if (!rider || !rider.name) return null;
  const meta = [rider.car, express ? '급송' : ''].filter(Boolean).join(' · ');
  return (
    <section className={cs.root}>
      <span className={cs.avatar}>{rider.name[0]}</span>
      <div>
        <span className={cs.name}>{rider.name} 기사님</span>
        {meta && <span className={cs.meta}>{meta}</span>}
      </div>
    </section>
  );
}

export default TrackRider;
